<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2 class="title">Style Editor</h2>
      <div class="close" (click)="bsModalRef.hide()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off" name="styleEditorForm" id="styleEditorForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="input-fields">
                <div>

                  <input style="margin: 5px;" type="checkbox" id="linecheckbox" name="linecheckbox" [(ngModel)]="userLayer.lineChecked">
                  <label for="">Line</label>
                  <input type="color" name="styleEditorLineColor" [disabled]="!userLayer.lineChecked" [(ngModel)]="userLayer.strokeColor" >
                  <select style="margin: 5px; width: 10%" [disabled]="!userLayer.lineChecked" [(ngModel)]="userLayer.lineWidth" name="lineThickness">
                    <option [value]="1">1</option>
                    <option [value]="2">2</option>
                    <option [value]="3">3</option>
                    <option [value]="5">5</option>
                    <option [value]="10">10</option>
                  </select>
                  <select style="margin: 5px; width: 10%" [disabled]="!userLayer.lineChecked" [(ngModel)]="userLayer.lineOpacity" name="lineOpacity">
                    <option [value]="0">0%</option>
                    <option [value]=".25">25%</option>
                    <option [value]=".5">50%</option>
                    <option [value]=".75">75%</option>
                    <option [value]="1">100%</option>
                  </select>
                </div>
                <div>
                  <input style="margin: 5px;" type="checkbox" id="fillcheckbox" name="fillcheckbox" [(ngModel)]="userLayer.fillChecked" [disabled]="fillCheckDisabled">
                  <label for="">Fill</label>
                  <input type="color" name="styleEditorFillColor" [disabled]="!userLayer.fillChecked" [(ngModel)]="userLayer.fillColor">
                  <select style="margin: 5px; width: 10%" [disabled]="!userLayer.fillChecked || fillCheckDisabled" [(ngModel)]="userLayer.fillOpacity" name="fillOpacity">
                    <option [value]="0">0%</option>
                    <option [value]=".25">25%</option>
                    <option [value]=".5">50%</option>
                    <option [value]=".75">75%</option>
                    <option [value]="1">100%</option>
                  </select>
                </div>
                <div>
                  <input style="margin: 5px;" type="checkbox" id="markcheckbox" name="markcheckbox" [(ngModel)]="userLayer.markerChecked" [disabled]="markerCheckDisabled">
                  <label for="">Marker</label>
                  <select style="margin: 5px; width: 10%" [disabled]="!userLayer.markerChecked || markerCheckDisabled" [(ngModel)]="userLayer.radius" name="radius">
                    <option [value]="1">1</option>
                    <option [value]="2">2</option>
                    <option [value]="3">3</option>
                    <option [value]="5">5</option>
                    <option [value]="10">10</option>
                  </select>
                  <select style="margin: 5px; width: 10%" [disabled]="!userLayer.markerChecked || markerCheckDisabled" name="markerShape" [(ngModel)]="userLayer.shape">
                    <option value="square">Square</option>
                    <option value="circle">Circle</option>
                    <option value="triangle">Triangle</option>
                    <option value="star">Star</option>
                    <option value="cross">Cross</option>
                    <option value="X">X</option>
                  </select>
                </div>
                <div>
                  <input style="margin: 5px;" type="checkbox" id="labelcheckbox" name="labelcheckbox"
                    [(ngModel)]="userLayer.labelChecked">
                    <label for="">Label</label>
                    <select style="margin: 5px; width: 10%" name="labelselect" [(ngModel)]="userLayer.propertyDisplayed" [disabled]="!userLayer.labelChecked">
                      <option *ngFor="let label of userLayer.labels" [value]="label">{{label}}</option>
                    </select>
                  </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" (click)="bsModalRef.hide()" class="blue">OK</button>
            <button type="submit" (click)="apply()" class="blue">Apply</button>
            <button type="submit" (click)="apply(true)" class="blue">Defaults</button>
            <button (click)="bsModalRef.hide()" class="gray">Cancel</button>

          </div>
        </form>
      </div>
    </div>
  </div>
</div>
